import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorCourseListLoader = async (args: LoaderFunctionArgs) => {

    const response = await networkCall(`/users/${ args.params.id }/courses`);

    return { getCoursesResponse: response, id: args.params.id };

};